export default __webpack_public_path__ + "static/media/Create-documentation.f60104e0.md";